<template>
    <div :style="{'background-color': $root.colorToHex('primary'), 'color': $root.colorToHex('primarytext'), 'padding': '10px', 'border-radius':'10px'}">
        <p style="margin: auto 0; font-size: 18px"> {{ computedText }}</p>
    </div>
</template>

<script>
export default {
    name: 'zoezi-visitors',

    zoezi: {
        title: 'Visitors',
        icon: 'mdi-account-multiple-outline'
    },
    props: {
        text: {
            title: 'Text',
            type: String,
            default: 'There are currently about {0} people in the building.'
        },
        visitorTime: {
            title: 'Average time for visitors',
            type: Number,
            default: 60
        },
        visitResources: {
            title: 'Count visits at these doors',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                multiple: true,
                text: 'name',
                value: 'id',
                getItems: () => {
                    return window.$zoeziapi.get('/api/resource/get').then(resources => {
                        const doors = resources.filter(resource => resource.resourceType == 'door' || resource.resourceType == 'qrcode_entry')
                        return doors.map(({lastname, id}) => ({name: lastname, id}));
                    })
                }
            },
            default: () => []
        },
    },

    computed: {
        computedText() {
            return this.$translate(this.text).format(this.visitorsCount);
        },
        hasMultiSites() {
            return this.$store.state.settings?.sites?.length > 1;
        }
    },

    data:() => ({
        visitorsCount: 0
    }),

    watch: {
        '$store.state.selectedSiteId': {
            immediate: true,
            handler() {
                this.fetchVisitorsCount();
            }
        }
    },

    methods: {
        fetchVisitorsCount() {
            // If no specific door is selected and there are multiple sites,
            // retrieve visitors for the specifically selected site.
            // This ensures proper functionality in the easy template for those with multiple sites.
            let getParameters = {visitorTime: this.visitorTime, doors: this.visitResources};
            if(this.hasMultiSites && this.$store.state.selectedSiteId && !this.visitResources.length) {
                getParameters = {visitorTime: this.visitorTime, siteId: this.$store.state.selectedSiteId};
            }
            this.$api.get("/api/public/entry/visitors/count", getParameters).then(data => {
                this.visitorsCount = data;
            }).catch(error => {
                console.error("Error fetching API data:", error);
            });
        }
    },

    mounted() {
        this.fetchVisitorsCount();
    }
}
</script>
